import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_yandexmetrikaplugin51beb6c0_1aba8075 from 'nuxt_plugin_yandexmetrikaplugin51beb6c0_1aba8075' // Source: ./yandex-metrika.plugin.51beb6c0.js (mode: 'client')
import nuxt_plugin_portalvue_9792e06c from 'nuxt_plugin_portalvue_9792e06c' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_vlazyload_a7a62f52 from 'nuxt_plugin_vlazyload_a7a62f52' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5545fbd1 from 'nuxt_plugin_cookieuniversalnuxt_5545fbd1' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_recaptcha_456b2018 from 'nuxt_plugin_recaptcha_456b2018' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_libplugin3694905f_4e518ef2 from 'nuxt_plugin_libplugin3694905f_4e518ef2' // Source: ./lib.plugin.3694905f.js (mode: 'all')
import nuxt_plugin_axios_eb1863ae from 'nuxt_plugin_axios_eb1863ae' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_5d059732 from 'nuxt_plugin_pluginutils_5d059732' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_9574a1f4 from 'nuxt_plugin_pluginseo_9574a1f4' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_3005c006 from 'nuxt_plugin_pluginrouting_3005c006' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_a201d6dc from 'nuxt_plugin_pluginmain_a201d6dc' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_image_757acb24 from 'nuxt_plugin_image_757acb24' // Source: ./image.js (mode: 'all')
import nuxt_plugin_datefns_411b61fa from 'nuxt_plugin_datefns_411b61fa' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_workbox_3e895d05 from 'nuxt_plugin_workbox_3e895d05' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_288bcf18 from 'nuxt_plugin_metaplugin_288bcf18' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_2d33748c from 'nuxt_plugin_iconplugin_2d33748c' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_directives_d0867c0c from 'nuxt_plugin_directives_d0867c0c' // Source: ../plugins/directives (mode: 'all')
import nuxt_plugin_errors_6a68cb3e from 'nuxt_plugin_errors_6a68cb3e' // Source: ../plugins/errors (mode: 'all')
import nuxt_plugin_components_6fb0430c from 'nuxt_plugin_components_6fb0430c' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_features_3c77ac9a from 'nuxt_plugin_features_3c77ac9a' // Source: ../plugins/features (mode: 'all')
import nuxt_plugin_firebaseclient_5389411b from 'nuxt_plugin_firebaseclient_5389411b' // Source: ../plugins/firebase.client.js (mode: 'client')
import nuxt_plugin_sticky_3a714642 from 'nuxt_plugin_sticky_3a714642' // Source: ../plugins/sticky (mode: 'client')
import nuxt_plugin_supportButton_d8601faa from 'nuxt_plugin_supportButton_d8601faa' // Source: ../plugins/supportButton (mode: 'client')
import nuxt_plugin_datepicker_4a26849c from 'nuxt_plugin_datepicker_4a26849c' // Source: ../plugins/datepicker (mode: 'client')
import nuxt_plugin_vtippy_c766a8d2 from 'nuxt_plugin_vtippy_c766a8d2' // Source: ../plugins/v-tippy (mode: 'client')
import nuxt_plugin_wysiwyg_52d539d7 from 'nuxt_plugin_wysiwyg_52d539d7' // Source: ../plugins/wysiwyg (mode: 'client')
import nuxt_plugin_verificationCode_48563bc4 from 'nuxt_plugin_verificationCode_48563bc4' // Source: ../plugins/verificationCode (mode: 'client')
import nuxt_plugin_dragscroll_6c5f1cf7 from 'nuxt_plugin_dragscroll_6c5f1cf7' // Source: ../plugins/dragscroll (mode: 'client')
import nuxt_plugin_vuegtagru_44731400 from 'nuxt_plugin_vuegtagru_44731400' // Source: ../plugins/vue-gtag-ru (mode: 'client')
import nuxt_plugin_socket_4695eaee from 'nuxt_plugin_socket_4695eaee' // Source: ../plugins/socket.js (mode: 'client')
import nuxt_plugin_fs_34e00758 from 'nuxt_plugin_fs_34e00758' // Source: ../plugins/fs.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Маркетплейс игровых товаров и услуг | Gaming-Goods","meta":[{"charset":"utf-8"},{"hid":"description","name":"description","content":"Маркетплейс игровых товаров и услуг | Gaming-Goods"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=yes, minimum-scale=1, maximum-scale=5"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@gaming_goods"},{"hid":"og:site_name","property":"og:site_name","content":"Gaming-Goods"},{"hid":"twitter:image","name":"twitter:image","content":"\u002Fshare_ru.png"},{"hid":"og:image","property":"og:image","content":"\u002Fshare_ru.png"},{"hid":"twitter:title","name":"twitter:title","content":"Маркетплейс игровых товаров и услуг | Gaming-Goods"},{"hid":"og:title","property":"og:title","content":"Маркетплейс игровых товаров и услуг | Gaming-Goods"},{"hid":"twitter:description","name":"twitter:description","content":"Маркетплейс игровых товаров и услуг | Gaming-Goods"},{"hid":"og:description","property":"og:description","content":"Маркетплейс игровых товаров и услуг | Gaming-Goods"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ficon.png"},{"href":"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js","rel":"preload","as":"script"}],"script":[{},{},{}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_yandexmetrikaplugin51beb6c0_1aba8075 === 'function') {
    await nuxt_plugin_yandexmetrikaplugin51beb6c0_1aba8075(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_9792e06c === 'function') {
    await nuxt_plugin_portalvue_9792e06c(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_a7a62f52 === 'function') {
    await nuxt_plugin_vlazyload_a7a62f52(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5545fbd1 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5545fbd1(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_456b2018 === 'function') {
    await nuxt_plugin_recaptcha_456b2018(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin3694905f_4e518ef2 === 'function') {
    await nuxt_plugin_libplugin3694905f_4e518ef2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_eb1863ae === 'function') {
    await nuxt_plugin_axios_eb1863ae(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_5d059732 === 'function') {
    await nuxt_plugin_pluginutils_5d059732(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_9574a1f4 === 'function') {
    await nuxt_plugin_pluginseo_9574a1f4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3005c006 === 'function') {
    await nuxt_plugin_pluginrouting_3005c006(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_a201d6dc === 'function') {
    await nuxt_plugin_pluginmain_a201d6dc(app.context, inject)
  }

  if (typeof nuxt_plugin_image_757acb24 === 'function') {
    await nuxt_plugin_image_757acb24(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_411b61fa === 'function') {
    await nuxt_plugin_datefns_411b61fa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_3e895d05 === 'function') {
    await nuxt_plugin_workbox_3e895d05(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_288bcf18 === 'function') {
    await nuxt_plugin_metaplugin_288bcf18(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_2d33748c === 'function') {
    await nuxt_plugin_iconplugin_2d33748c(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_d0867c0c === 'function') {
    await nuxt_plugin_directives_d0867c0c(app.context, inject)
  }

  if (typeof nuxt_plugin_errors_6a68cb3e === 'function') {
    await nuxt_plugin_errors_6a68cb3e(app.context, inject)
  }

  if (typeof nuxt_plugin_components_6fb0430c === 'function') {
    await nuxt_plugin_components_6fb0430c(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  if (typeof nuxt_plugin_features_3c77ac9a === 'function') {
    await nuxt_plugin_features_3c77ac9a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_firebaseclient_5389411b === 'function') {
    await nuxt_plugin_firebaseclient_5389411b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sticky_3a714642 === 'function') {
    await nuxt_plugin_sticky_3a714642(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_supportButton_d8601faa === 'function') {
    await nuxt_plugin_supportButton_d8601faa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_4a26849c === 'function') {
    await nuxt_plugin_datepicker_4a26849c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtippy_c766a8d2 === 'function') {
    await nuxt_plugin_vtippy_c766a8d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_wysiwyg_52d539d7 === 'function') {
    await nuxt_plugin_wysiwyg_52d539d7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_verificationCode_48563bc4 === 'function') {
    await nuxt_plugin_verificationCode_48563bc4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dragscroll_6c5f1cf7 === 'function') {
    await nuxt_plugin_dragscroll_6c5f1cf7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegtagru_44731400 === 'function') {
    await nuxt_plugin_vuegtagru_44731400(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socket_4695eaee === 'function') {
    await nuxt_plugin_socket_4695eaee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fs_34e00758 === 'function') {
    await nuxt_plugin_fs_34e00758(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
